import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useDispatch } from "react-redux";
import { updateL1Property } from "../../WorkbookSlice";
import { setSheetControls } from "../../WorkbookControllingSlice";

export default function VizStyle({
  closeModal,
  SheetDetails,
  setVizType,
  currentVizTpe,
}) {
  const SheetIdchart = SheetDetails.Sheetid;
  const dispatch = useDispatch();
  const [selectedChart, setSelectedChart] = useState(null);
  console.log(selectedChart);
  console.log(currentVizTpe);
  const handleIconClick = (event, chart) => {
    event.stopPropagation(); // Stop click event from bubbling up to parent elements
    setVizType(chart);
    setSelectedChart(chart);
    console.log(chart);
    // if current vizType is cordinate map and new vizType is not cordinate map playing the paused query
    if (currentVizTpe === "cordinatemap" && chart !== "cordinatemap") {
      console.log("jio");
      dispatch(
        setSheetControls({
          Sheetid: SheetIdchart,
          controls: {
            isPause: false,
          },
        })
      );
    }
    dispatch(
      updateL1Property({
        SheetId: SheetIdchart,
        key: "VizType",
        value: chart,
        currentVizTpe: currentVizTpe,
      })
    );
    closeModal();
  };

  return (
    <main className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-50">
      <section className="flex flex-col gap-2 w-96 h-[80%] bg-white rounded shadow-2xl z-20">
        <div className="flex justify-between items-center font-medium p-2 bg-gray-50">
          Select a chart
          <RxCross2 className="cursor-pointer" onClick={closeModal} />
        </div>
        <section className="grid grid-cols-3 grid-rows-4 items-center justify-center gap-x-2 gap-y-2 overflow-y-auto w-full pl-6 pt-2">
          {[
            {
              iconSrc: "/graph_img/Table.png",
              label: "Pivot Table",
              value: "simpleTable",
            },
            {
              iconSrc: "/graph_img/Table.png",
              label: "Table",
              value: "table",
            },
            {
              iconSrc: "/graph_img/Piechart.png",
              label: "Pie",
              value: "piechart",
            },
            {
              iconSrc: "/graph_img/Linechart.png",
              label: "Line",
              value: "linechart",
            },
            {
              iconSrc: "/graph_img/Areachart.png",
              label: "Area",
              value: "areachart",
            },
            {
              iconSrc: "/graph_img/Stackbarchart.png",
              label: "Stacked-Bar",
              value: "stackedbarchart",
            },
            {
              iconSrc: "/graph_img/Stackbarchart.png",
              label: "StackedImage",
              value: "stackedbarchartimage",
            },
            {
              iconSrc: "/graph_img/Bubblechart.png",
              label: "Scatter",
              value: "scatterchart",
            },
            {
              iconSrc: "/graph_img/Treechart.png",
              label: "Tree",
              value: "treechart",
            },
            //radarchart
            {
              iconSrc: "../graph_img/radar.png",
              label: "Radar",
              value: "radarchart",
            },
            //combochart
            {
              iconSrc: "../graph_img/combochart.png",
              label: "Combo",
              value: "combochart",
            },
            //sankeychart
            // {
            //   iconSrc: "../graph_img/sankeychart.png",
            //   label: "Sankey",
            //   value: "sankeychart",
            // },

            //bigNumber
            {
              iconSrc: "/graph_img/bignumber.png",
              label: "BigNumber",
              value: "bigNumber",
            },
            // {
            //   iconSrc: "/graph_img/bignumber.png",
            //   label: "BigNumber",
            //   value: "bigNumberheading",
            // },

            // { iconSrc: "/graph_img/Mapchart.png", label: "Map", value: "map" },
            {
              iconSrc: "/graph_img/Mapchart.png",
              label: "PointsMap",
              value: "cordinatemap",
            },
            {
              iconSrc: "/graph_img/Mapchart.png",
              label: "AreaMap",
              value: "areamap",
            },
          ].map((chart, index) => (
            <button
              key={index}
              className={`w-[65%] flex flex-col items-center justify-center cursor-pointer `}
              onClick={(event) => handleIconClick(event, chart.value)}
            >
              <img
                src={chart.iconSrc}
                width={250}
                className={`p-2 border rounded-md hover:shadow object-fill ${selectedChart === chart.value
                  ? "border-blue-700"
                  : "border-blue-100"
                  }`}
              />
              <label className="font-light ">{chart.label}</label>
            </button>
          ))}
        </section>
      </section>
    </main>
  );
}